// extracted by mini-css-extract-plugin
export default {"headerSelect":"headerSelect_headerSelect__7spx8"};